import { connect } from 'react-redux';

import OrderDetail from './orderDetail';
import { getOrderDetailStatus, getOrderDetailData } from './store/selectors';
import { getProfileData } from '../login/store/selectors';
import { loadOrderDetail, fileDownload } from './store/action-creators';
import { loadCheckboxSettings } from '../orderBuilder/store/action-creators';
import { getCheckboxSettingsData } from "../orderBuilder/store/selectors";


const mapStateToProps = (state) => ({
  orderDetailStatus: getOrderDetailStatus(state),
  orderDetailData: getOrderDetailData(state),
  checkboxSettingsData: getCheckboxSettingsData(state),
  profileData: getProfileData(state),
});

const mapDispatchToProps = {
  loadOrderDetail,
  loadCheckboxSettings,
  fileDownload,
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);